let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      // One subscriber throwing (or returning a rejected promise) must not stop the others from
      // running, and must not propagate back into whatever code called publish() - a plain
      // forEach with no try/catch here previously let a single bad subscriber silently cancel
      // every subscriber registered after it, plus any code the publisher itself ran afterward.
      try {
        const result = callback(data);
        if (result && typeof result.catch === 'function') {
          result.catch((error) => console.error(error));
        }
      } catch (error) {
        console.error(error);
      }
    });
  }
}
